import { IVector3 } from '@easytwin/runtime';

export function isNil(v: unknown): v is null | undefined {
  return v === null || v === undefined;
}

export function isString(value: unknown): value is string {
  return typeof value === 'string';
}

export function isObject(data: unknown) {
  return Object.prototype.toString.call(data) === '[object Object]';
}

export function isArray(arr: unknown): arr is unknown[] {
  return Array.isArray(arr);
}

export function isNumber(value: any): value is number {
  if (typeof value === 'number') {
    return !isNaN(value);
  }
  return false;
}

export type IVector3Like = IVector3 & Record<string, any>;

export function isIVector3Array(obj: unknown, isStrict: true): obj is IVector3[];
export function isIVector3Array(obj: unknown, isStrict: false): obj is IVector3Like[];

export function isIVector3Array(obj: unknown, isStrict: boolean = false): obj is IVector3[] {
  if (!Array.isArray(obj)) {
    return false;
  }

  for (const item of obj) {
    if (typeof item !== 'object' || !('x' in item) || !('y' in item) || !('z' in item)) {
      return false;
    }
  }

  if (isStrict) {
    for (const item of obj) {
      if (Object.keys(item).length !== 3) {
        return false;
      }
    }
  }

  return true;
}

export function isLonLatArray(obj: unknown): obj is {
  lon: number;
  lat: number;
  alt: number;
}[] {
  if (!Array.isArray(obj)) {
    return false;
  }
  for (const item of obj) {
    if (typeof item !== 'object' || !('lon' in item) || !('lat' in item) || !('alt' in item)) {
      return false;
    }
  }
  return true;
}
